import api, { apiErrorHandler } from "api";
import { StatsParams } from "api/types";
import { AxiosError, AxiosResponse } from "axios";

const requestHandler =
  (request: (params: StatsParams) => Promise<AxiosResponse>) =>
  (
    params: StatsParams,
    onLoading: (status: boolean) => void,
    onSuccess: (res: any) => void,
    onError?: (err: AxiosError) => void,
  ) => {
    onLoading(true);
    return request(params)
      .then((res) => {
        if (res.data) onSuccess(res.data);
        onLoading(false);
      })
      .catch(
        apiErrorHandler((error) => {
          onLoading(false);
          if (onError) onError(error);
        }),
      );
  };

export const handleGetDAStatusStats = async (
  params: any,
  onLoading: (status: boolean) => void,
  onSuccess: (res: any) => void,
  onError?: (err: AxiosError) => void,
) => {
  return await requestHandler(api.getDAStatusStats)(params, onLoading, onSuccess, onError);
};

export const handleGetFleetStatusStats = async (
  params: any,
  onLoading: (status: boolean) => void,
  onSuccess: (res: any) => void,
  onError?: (err: AxiosError) => void,
) => {
  return await requestHandler(api.getFleetStatusStats)(params, onLoading, onSuccess, onError);
};
